import { BRIDGE_SITE_PATH_LIST } from "./bridgeSitePaths";
import patchHrefLocale from "./patchHrefLocale";
import replaceMappedPath from "./replaceMappedPath";

type ParsedHrefProps = {
  href: string | { pathname?: string; [key: string]: unknown };
  language: string;
  domain: string;
  defaultLang: string;
  isBridgeSite: boolean;
};

const getParsedHref = (props: ParsedHrefProps) => {
  const { href, isBridgeSite, domain } = props;

  if (href instanceof Object) {
    return { isExternal: false, href };
  }

  if (!isBridgeSite) {
    const isExternal = href.includes("://");
    return { isExternal, href };
  }

  const mappedHref = replaceMappedPath(href);
  for (const path of BRIDGE_SITE_PATH_LIST) {
    if (mappedHref.startsWith(path)) {
      const patchedHref = patchHrefLocale({ ...props, href: mappedHref });
      return { isExternal: true, href: `https://${domain}${patchedHref}` };
    }
  }

  const isExternal = mappedHref.includes("://");
  return { isExternal, href: mappedHref };
};

export default getParsedHref;
